<script>
export default {
    props: {
        label: [String, Number],
        tooltip: [String, Number],
    }
}
</script>

<template>
    <v-tooltip
        :disabled="!tooltip"
        right
    >
        <template v-slot:activator="{ on, attrs }">
             <span
                 v-bind="attrs"
                 v-on="on"
             >
                 {{ label }}
             </span>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<style scoped>

</style>